export default {
  'en-US': { name: 'English', name_en: 'English', rtl: false },
  'fr-FR': { name: 'Français', name_en: 'French', rtl: false },
  'es-ES': { name: 'Español', name_en: 'Spanish (Spain)', rtl: false },
  'es-MX': { name: 'Español (México)', name_en: 'Spanish (Mexican)', rtl: false },
  'de-DE': { name: 'Deutsch', name_en: 'German', rtl: false },
  'ru-RU': { name: 'Pусский', name_en: 'Russian', rtl: false },
  'ar-QA': { name: 'العربية', name_en: 'Arabic (Qatar)', rtl: true },
  ar: { name: '(ا (قطر', name_en: 'Arabic', rtl: true },
  'he-IL': { name: 'עברית', name_en: 'Hebrew', rtl: true },
  'nl-NL': { name: 'Nederlands', name_en: 'Dutch', rtl: false },
  'da-DK': { name: 'Dansk', name_en: 'Danish', rtl: false },
  'pt-PT': { name: 'Português', name_en: 'Portuguese (Portugal)', rtl: false },
  'pt-BR': { name: 'Português (Brasil)', name_en: 'Portuguese (Brazil)', rtl: false },
  'zh-CN': { name: '简体中文', name_en: 'Simplified Chinese', rtl: false },
  'zh-TW': { name: '繁體中文（台灣）', name_en: 'Traditional Chinese (Taiwan)', rtl: false },
  'zh-HK': { name: '繁體中文', name_en: 'Traditional Chinese (Hong Kong)', rtl: false },
  'ja-JP': { name: '日本語', name_en: 'Japanese', rtl: false },
  'ko-KR': { name: '한국어', name_en: 'Korean', rtl: false },
  'vi-VN': { name: 'Tiếng Việt', name_en: 'Vietnamese', rtl: false },
  'th-TH': { name: 'ไทย ', name_en: 'Thai', rtl: false },
  'is-IS': { name: 'Íslensku', name_en: 'Icelandic', rtl: false },
  'nb-NO': { name: 'Norsk', name_en: 'Norwegian, Bokmal (Norway)', rtl: false },
  'nn-NO': { name: 'Nynorsk', name_en: 'Norwegian, Nynorsk (Norway)', rtl: false },
  'it-IT': { name: 'Italiano', name_en: 'Italian', rtl: false },
  'sv-SE': { name: 'Svenska', name_en: 'Swedish', rtl: false },
  'id-ID': { name: 'Indonesia', name_en: 'Indonesian', rtl: false },
  'cs-CZ': { name: 'Čeština', name_en: 'Czech', rtl: false },
  'en-GB': { name: 'English (United Kingdom)', name_en: 'English UK', rtl: false },
  'pl-PL': { name: 'Polski', name_en: 'Polish', rtl: false },
  'tr-TR': { name: 'Türkçe', name_en: 'Turkish', rtl: false },
  'fi-FI': { name: 'Suomalainen', name_en: 'Finnish', rtl: false },
  'sk-SK': { name: 'Slovenčina', name_en: 'Slovak', rtl: false },
  'el-GR': { name: 'Ελληνικά', name_en: 'Greek', rtl: false },
  'hu-HU': { name: 'Magyar', name_en: 'Hungarian', rtl: false },
  'cy-GB': { name: 'Cymraeg', name_en: 'Welsh (United Kingdom)', rtl: false },
  'ca-ES': { name: 'Català', name_en: 'Catalan', rtl: false },
  'ms-MY': { name: 'Bahasa Melayu', name_en: 'Malay', rtl: false },
  'af-ZA': { name: 'Afrikaans', name_en: 'African', rtl: false },
}
